import { IconProps } from './index';

export const IconMenu = ({ className }: IconProps) => (
  <svg width="26" height="14" xmlns="http://www.w3.org/2000/svg" className={className}>
    <g
      stroke="#4A4A4A"
      strokeWidth="1.8"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1.48 1.28H25M1.48 7.04H25M1.48 12.8H25" />
    </g>
  </svg>
);
